<template>
  <span class="sub-text-title">
    <slot />
  </span>
</template>
<script>
export default {
  name: 'SubTextTitle',
};
</script>
<style scoped lang="scss">
.sub-text-title {
  font-size: 25px;
  margin: 20px auto 20px;
  font-weight: 800;
  padding: 0 20px;
}
</style>
